import { connectRefinementList } from "instantsearch.js/es/connectors";
import { useState } from "nuxt/app";
import { provide, ref } from "vue";
export const useAisRefinementListRenderState = () => useState(
  "ais_refinement_render_state",
  () => ({})
);
export const useAisRefinementList = (widgetParams, id = "") => {
  const stateRef = ref();
  const refinementRenderState = useAisRefinementListRenderState();
  const renderRefinementList = (renderState, isFirstRender) => {
    stateRef.value = renderState;
    if (import.meta.client) {
      refinementRenderState.value[widgetParams.attribute] = renderState;
    }
    if (isFirstRender) {
      provide(`refinementList-${id}`, stateRef);
    }
    return () => null;
  };
  const customRefinementList = connectRefinementList(renderRefinementList);
  return {
    ...customRefinementList(widgetParams),
    $$widgetParams: widgetParams,
    $$widgetId: id
  };
};
